import config from 'global-variables';
import { useQuery } from 'react-query';
import { getToken } from './useLogin';
import { ProviderOrderDetails } from 'types/Orders';

async function getProviderOrderDetails({ orderId }: { orderId?: string }): Promise<ProviderOrderDetails | null> {
    const token = getToken();
    if (!token || !orderId) return null;
    const host = config.restAPIUrl;
    const res = await fetch(`${host}/orders/provider/detail/${orderId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });
    const data = await res.json();
    return data as ProviderOrderDetails;
}

export function useGetProviderOrderDetails(orderId?: string) {
    return useQuery(['provider-order-details', orderId?.toString()], () => getProviderOrderDetails({ orderId }), {
        refetchInterval: 0,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
}
